import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, switchMap } from "rxjs/operators";
import { AcsActions } from "./acs.actions";
import { liveLessonAuthActions } from "@pcp/auth";
import { ChatApiService } from "../chat-api.service";
import { of } from "rxjs";

@Injectable()
export class AcsEffects {

    private readonly chatApi = inject(ChatApiService);

    loadAcsCredentials$ = createEffect(() => this.actions$.pipe(
        ofType(
            liveLessonAuthActions.userLoginSuccess,
            liveLessonAuthActions.tokenRestoreSuccess,
        ),
        map(action => AcsActions.fetchAcsCredentialsSuccess({
            acsGroupId: action.tokenData.liveLesson.azureCommunicationGroupId,
            acsDisplayName: action.tokenData.liveLesson.displayName,
            acsToken: action.tokenData.liveLesson.azureCommunicationToken,
            acsUserId: action.tokenData.liveLesson.communicationUserId,
        })),
        catchError(error => of(AcsActions.fetchAcsCredentialsFailed({ error }))),
    ));

    constructor(private actions$: Actions) {
    }
}
